import prepareComponent from "@bluframe/grapple/prepareComponent"
import {
  NewsServiceName,
  ReviewsServiceName
} from "@bluframe/mightychroma-mightytool-frontend-types"
import { FormEventHandler, useState } from "react"

import PodSource from "./PodSource"

export interface Props {
  areItemsLoading: boolean
  isCompact: boolean
  isCreated: boolean
  isLoading: boolean
  isValid: boolean
  itemLabel: "News" | "Reviews"
  label: string
  onCancel: () => void
  onClear: () => void
  onSave: () => void
  modalContent: React.ReactNode
  serviceName: NewsServiceName | ReviewsServiceName
  text: string
}

export interface ComponentProps extends Omit<Props, "onSave"> {
  isEditOpen: boolean
  onSave: FormEventHandler

  onSetIsEditOpen: (isOpen: boolean) => () => void
}

const DEFAULT_IS_EDIT_OPEN = false

const usePrepareComponent = ({ ...props }: Props): ComponentProps => {
  const [isEditOpen, setIsEditOpen] = useState<boolean>(DEFAULT_IS_EDIT_OPEN)

  const onSetIsEditOpen = (isOpen: boolean) => () => {
    setIsEditOpen(isOpen)
  }

  const onCancel = () => {
    props.onCancel()
    setIsEditOpen(false)
  }

  const onSave: FormEventHandler = (event) => {
    event.preventDefault()

    props.onSave()
    setIsEditOpen(false)
  }

  return {
    ...props,
    isEditOpen,
    onCancel,
    onSave,
    onSetIsEditOpen
  }
}

export default prepareComponent(usePrepareComponent)(PodSource)
